export const TableFormProp = Object.freeze({
    TableFormHeader: 'tableFormHeader',
    TableFormDataRows: 'tableFormDataRows',
    TableFormDataRowsForDelete: 'tableFormDataRowsForDelete',
    TableFormFooter: 'tableFormFooter',
    TableFormButtons: 'tableFormButtons',
    TableFormTitle: 'tableFormTitle',
    TableFormExpand: 'tableFormExpand',
});